














































































































































































































































































import {Component, Inject, Watch} from "vue-property-decorator";
import BaseApi from "../../store/modules/base";
import ArrowInIcon from "./ArrowInIcon.vue";
import ArrowOutIcon from "./ArrowOutIcon.vue";
import {
  ApiMessage,
  DateTime,
  GeoCircle, GeofenceStatusCode,
  GeoPoint,
  GeoPolygon,
  IdCard,
  InOutAvailableLocation,
  JLocation,
  TerminalLocation, HseGuideline, BackgroundLocationPermission,
} from "../../modules/models";
import {gmapApi} from "vue2-google-maps";
import {
    ErrorColor,
    GoogleMapsInitLocation,
    InfoColor, MaxRegreminderLocationsPerUser,
    PrimaryColor,
    SecondaryColor,
    WarningColor
} from "../../modules/constants";
import Api from "./Api";
import GeoApi, {
  geoDeniedNonPromptable,
  geoGranted,
  geoGrantedInaccurateNonpromptable,
  geoGrantedInaccuratePromptable,
  geoNotAvailable,
  geoNotPrompted,
  geoUnknown
} from "../../store/modules/geo";
import EllipsisScroller from "../EllipsisScroller.vue";
import {isIosSafari, Runbouncer} from "../../modules/utils";
import HmsCardDisplay from "../HmsCardDisplay.vue";
import CardIcon from "../CardIcon.vue";
import delay from "../../modules/delay";
import rd from "../../modules/vRoutedefs";
import UserRequired from "../UserRequired";

import {initVueGoogleMaps} from "@/modules/maps";
import {NativeApi} from "@/modules/NativeBridge";
import HseVerifDialog from "@/components/sio/HseVerifDialog.vue";
import ForegroundLocationReason from "@/components/sio/ForegroundLocationReason.vue";
import CommonBase from "@/components/CommonBase";
import EnableBackgroundLocationDlg from "@/components/sio/EnableBackgroundLocationDlg.vue";
import AppReviewTrigger from "@/modules/AppReviewTrigger";
import RegReminderEnablement from "@/components/sio/RegReminderEnablement.vue";

initVueGoogleMaps();

@Component({
    components: {
        "at-arrow-in": ArrowInIcon,
        "at-arrow-out": ArrowOutIcon,
        "at-ellipsier": EllipsisScroller,
        "at-card-display": HmsCardDisplay,
        "at-card-icon": CardIcon,
        "at-hse-verif-dialog": HseVerifDialog,
        "at-foreground-location-reason": ForegroundLocationReason,
        "at-regreminder-enablement": RegReminderEnablement,
    }
})
export default class SioReg extends UserRequired {
    @Inject()
    baseApi!: BaseApi;
    @Inject()
    geoApi!: GeoApi;
    @Inject()
    api!: Api;
    @Inject()
    nativeApi!: NativeApi;

    geoGranted = geoGranted;
    geoNotAvailable = geoNotAvailable;
    geoNotPrompted = geoNotPrompted;
    geoGrantedInaccuratePromptable = geoGrantedInaccuratePromptable;
    geoGrantedInaccurateNonpromptable = geoGrantedInaccurateNonpromptable;
    geoDenied = geoDeniedNonPromptable;
    secondaryColor = SecondaryColor;
    errorColor = ErrorColor;
    warningColor = WarningColor;
    initMapCenter = GoogleMapsInitLocation;

    get geoAvailability() {
        return this.geoApi.availability;
    }
    get geoError() {
        return this.geoApi.error;
    }
    get geoListenerActive() {
        return this.geoApi.active;
    }
    get geoListenerPending() {
        return this.geoApi.pending;
    }

    get activeSio() {
        return this.baseApi.activeSio;
    }

    @Watch("geoAvailability")
    onGeoAvailabilityChanged() {
        if(this.geoAvailability == geoGranted || this.geoAvailability == geoUnknown) {
            if(!this.geoApi.active) {
                this.geoApi.startGeolistener();
            }
        }
    }

    mapCenter: google.maps.LatLngLiteral = this.initMapCenter;

    get myposition(): JLocation | null {
        return this.geoApi.position;
    }
    reloadPosition: JLocation | null = null;

    mapOptions = {
        mapTypeControl: false,
        streetViewControl: false,
    };

    get googReady() {
        return gmapApi();
    }
    @Watch("googReady")
    onGoogReady() {
        this.$emit("googReady", this.googReady);
    }
    googleWaiter() {
        if(this.googReady) {
            return Promise.resolve(this.googReady);
        }
        return new Promise<any>((resolve) => {
            this.$once("googReady", resolve);
        });
    }

    @Watch("myposition", {immediate: true})
    onPositionChanged() {
        /* eslint-disable */
        if(this.myposition != null) {
            // Only trigger load of locations if there is significant change in position.
            let doReload = true;
            if(this.reloadPosition != null) {
                const mp = new google.maps.LatLng(this.myposition.latitude, this.myposition.longitude);
                const rp = new google.maps.LatLng(this.reloadPosition.latitude, this.reloadPosition.longitude);
                const diffMeters = google.maps.geometry.spherical.computeDistanceBetween(mp , rp);
                doReload = diffMeters > 1; // Do reload if postion changed more than 1 meters
            }
            if(doReload) {
                this.mapCenter = this.myposition.asLatLng();
                this.loadAvailableInOutLocations();
            }
        }
        /* eslint-enable */
    }

    mapLoaded = false;

    get initZoom() {
        return 15;
    }

    get mypositionIcon() {
        /* eslint-disable */
        return {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: "#1d7c14",
            fillOpacity: 0.8,
            scale: 6,
            strokeColor: "#ffffff",
            strokeOpacity: 1.0,
            strokeWeight: 2,
        };
        /* eslint-enable */
    }
    async startGeolistener() {
        await this.geoApi.startGeolistener();
    }
    async checkAvailability() {
        await this.geoApi.checkAvailability();
        if(this.geoApi.availability > geoNotPrompted) {
            this.snackErrorMsg("Posisjonstjeneste fremdeles utilgjengelig");
        } else if(this.geoApi.availability == geoUnknown || this.geoApi.availability == geoNotPrompted) {
            this.snackSuccessMsg("Posisjonsteneste kan nå startes");
        }
    }
    async retryPosition() {
        await this.checkAvailability();
        this.onGeoAvailabilityChanged(); // Try calling this manually to trigger restart of geolistener even when it has not really changed.
    }

    get positionSettingsFixPossible() {
        return this.nativeApi.available && this.nativeApi.atleastVersion(0, 3, 0);
    }

    showEnableBackgroundLocation = false;
    async promptEnableBackgroundLocation(): Promise<boolean> {
      const ref = this.$refs["EnableBackgroundLocationDlg"] as EnableBackgroundLocationDlg;
      const retPromise = CommonBase.oneEventPromise(ref, "at-enable-background-location").then(result => result === true);
      this.showEnableBackgroundLocation = true;
      const ret = await retPromise;
      this.showEnableBackgroundLocation = false;
      return ret;
    }

    appSettingsOpen = false;
    async openAppSettings() {
      try {
        this.appSettingsOpen = true;
        const opened = await this.nativeApi.openAppSettings();
        if (opened) { // App settings was opened, and user returned to app
          await this.checkAvailability();
        } else {
          this.emitSnack(`Åpning av app innstillinger feilet.`, "error");
        }
      } finally {
        this.appSettingsOpen = false;
      }
    }

    loadBouncer = new Runbouncer(10000); // Ten seconds debounce
    availableInOutLocations: InOutAvailableLocation[] | null = null;

    async loadAvailableInOutLocations() {
        if(this.myposition != null) {
            if(await this.loadBouncer.bounce()) {
                try {
                    this.availableInOutLocations = await this.api.fetchAvailableTerminalLocations(this.myposition.asGeoPoint());
                } catch (e) {
                    this.availableInOutLocations = [];
                    this.emitError(e);
                }
            }
        } else {
            this.availableInOutLocations = [];
        }
        this.reloadPosition = this.myposition;
    }

    get locationCircles(): GeoCircle[] {
        let circles: GeoCircle[] = [];
        if(this.availableInOutLocations != null) {
            for (let l of this.availableInOutLocations) {
                for (let a of l.areas) {
                    if (a.geo instanceof GeoCircle) {
                        if(this.nextInLocation != null && this.nextInLocation.locid === l.locid) {
                            a.geo.strokeColor = SecondaryColor;
                        } else if(this.regcodeLocation != null && this.regcodeLocation.id === l.locid) {
                            a.geo.strokeColor = InfoColor;
                        } else {
                            a.geo.strokeColor = PrimaryColor;
                        }
                        circles.push(a.geo);
                    }
                }
            }
        }
        return circles;
    }
    get locationPolygons(): GeoPolygon[] {
        let ps: GeoPolygon[] = [];
        if(this.availableInOutLocations != null) {
            for (let l of this.availableInOutLocations) {
                for (let a of l.areas) {
                    if (a.geo instanceof GeoPolygon) {
                        if(this.nextInLocation != null && this.nextInLocation.locid === l.locid) {
                            a.geo.strokeColor = SecondaryColor;
                        } else if(this.regcodeLocation != null && this.regcodeLocation.id === l.locid) {
                            a.geo.strokeColor = InfoColor;
                        } else {
                            a.geo.strokeColor = PrimaryColor;
                        }
                        ps.push(a.geo);
                    }
                }
            }
        }
        return ps;
    }
    get terminalPoints(): GeoPoint[] {
        let allTps: GeoPoint[] = [];
        if(this.availableInOutLocations != null) {
            for (let l of this.availableInOutLocations) {
                for (let tps of l.terminalPositions) {
                    allTps = allTps.concat(tps);
                }
            }
        }
        return allTps;
    }

    // Calculate locations the current position is within
    @Watch("availableInOutLocations")
    async onAvailableInOutLocationsChanged() {
        let withinCensoredArea = false;
        let calc = new Set<InOutAvailableLocation>();
        try {
            /* eslint-disable */
            if(this.myposition != null) {
                const mp = this.myposition.asLatLng();
                if (this.availableInOutLocations != null) {
                    for (let l of this.availableInOutLocations) {
                        // If location doesn't require geoposition control, and regcode is registered, it is available
                        if(!l.geoRequired && l.regcodeRegistered && l.regcodeExpired == null) {
                            calc.add(l);
                        } else {
                            for (let a of l.areas) {
                                if (a.geo instanceof GeoCircle) {
                                    const c = a.geo.center.asLatLng();
                                    await this.googleWaiter();
                                    const distanceToCenter = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(mp.lat, mp.lng), new google.maps.LatLng(c.lat, c.lng));
                                    if (distanceToCenter < a.geo.radius) {
                                        calc.add(l);
                                    }
                                } else if (a.geo instanceof GeoPolygon) {
                                    await this.googleWaiter();
                                    const poly = new google.maps.Polygon({paths: a.geo.points.map((p) => p.asLatLng())});
                                    if (google.maps.geometry.poly.containsLocation(new google.maps.LatLng(mp.lat, mp.lng), poly)) {
                                        calc.add(l);
                                    }
                                }
                            }
                            if (l.areas.length === 0 && l.regcodeRequired && !(l.regcodeRegistered || l.regcodeExpired != null)) {
                                // Location is "regcode censored", hidden because user has not registered regcode yet
                                withinCensoredArea = true;
                            }
                        }
                    }
                }
            }
            /* eslint-enable */
        } catch(err) {
            this.emitError(err);
        }
        this.withinCensoredArea = withinCensoredArea;
        this.inLocations = Array.from(calc);

        let regcodeProcess = 0;
        if(this.regcodeLocation != null) {
            // check if regcode location is within inLocations, select it for next reg in if so.
            const nextIn = this.inLocations.find((r) => this.regcodeLocation != null && r.locid === this.regcodeLocation.id) || null;
            if (nextIn != null) {
                this.startRegIn(nextIn);
            } else {
                this.nextInLocation = null;
            }

        } else if(calc.size == 1 && !this.withinCensoredArea) {
            this.startRegIn(calc.values().next().value /* first value in calc */);

        } else if(this.nextInLocation != null) {
            // If location is set, check that it is still valid. Reset if not.
            const ni: InOutAvailableLocation = this.nextInLocation;
            if(!this.inLocations.some((l) => l.locid === ni.locid)) {
                this.nextInLocation = null;
            }
        } else if (calc.size == 0 && this.withinCensoredArea) {
            regcodeProcess = 1; // Display field for inputting regcode directly
        }
        this.regcodeProcess = regcodeProcess;
        this.regcodeRegistering = false; // This is set in registerRegcode and not unset there to keep the loading state until available locations have been resolved.
    }

    get regOutLocationNearby() {
      return this.activeSio != null && this.inLocations.some((r) => this.activeSio != null && r.locid === this.activeSio.terminalLocation.id);
    }

    get regcodeLocationNearby() {
        return this.regcodeLocation != null && this.nextInLocation == null && this.availableInOutLocations != null &&
            this.availableInOutLocations.some((r) => this.regcodeLocation != null && r.locid === this.regcodeLocation.id);
    }

    get regcodeLocationFaraway() {
        return this.regcodeLocation != null && this.nextInLocation == null && !this.regcodeLocationNearby;
    }

    inLocations: InOutAvailableLocation[] = [];
    nextInLocation: InOutAvailableLocation | null = null;
    withinCensoredArea: boolean = false;

    isUnvRegBlocked(locinfo: InOutAvailableLocation): boolean {
        if(locinfo.unverifiedRegOk) {
            return false;
        }
        return !this.user.isVerified();
    }

    get showUnvRegNotOkInfo(): boolean {
        if(this.nextInLocation == null) {
            return false;
        }
        return this.isUnvRegBlocked(this.nextInLocation);
    }

    startRegIn(locinfo: InOutAvailableLocation) {
        this.nextInLocation = locinfo;
        if(this.activeCards.length == 1) {
            this.nextInCard = this.activeCards[0];
        }
    }

    get showBackBtn() {
        if(this.activeSio != null) {
            return false;
        }
        return (this.nextInLocation != null && this.inLocations.length > (this.withinCensoredArea ? 0 : 1)) ||
            this.showCardChoice || this.regcodeProcess > 0 || this.regcodeLocation != null;
    }

    back() {
        if(this.nextInCard != null && this.activeCards.length > 1) {
            this.nextInCard = null;
        } else if(this.showCardChoice) {
            this.showCardChoice = false;
        } else if(this.regcodeLocation != null) {
            this.regcodeLocation = null;
            this.regcodeProcess = 1;
            this.onAvailableInOutLocationsChanged(); // Re calculate nextInLocation
        } else if(this.nextInLocation != null) {
            this.nextInLocation = null
        } else if(this.regcodeProcess > 0) {
            this.regcodeProcess--;
        }
    }

    // List of cards the user is allowed to register in with
    get activeCards(): IdCard[] {
        const now = DateTime.now();
        let newestExpiredCard: IdCard | null = null;
        let activeCards = new Map<number, IdCard>();
        for(let card of this.user.cards) {
            if((card.deactivated != null && card.deactivated.isBefore(now)) || card.isExpired()) { // Expired card
                if(newestExpiredCard == null || newestExpiredCard.expirationDate.isBefore(card.expirationDate)) {
                    newestExpiredCard = card;
                }
            } else { // Active card
                // Only add card if it is the users newest connected to it's company
                const existingCompanyCard = activeCards.get(card.orgNum) || null;
                if(existingCompanyCard == null || existingCompanyCard.expirationDate.isBefore(card.expirationDate)) {
                    activeCards.set(card.orgNum, card);
                }
            }
        }
        if(activeCards.size > 0) {
            return Array.from<IdCard>(activeCards.values());
        } else if(newestExpiredCard != null) {
            return [newestExpiredCard];
        }
        return [];
    }
    get hasCard() {
        return this.activeCards.length > 0;
    }
    nextInCard: IdCard | null = null;
    showCardChoice = false;

    cardExpirationClass(card: IdCard): string {
        if(card.isExpired()) {
            return "error--text";
        } else if(card.isSoonExpired()) {
            return "warning--text";
        }
        return "";
    }

    registering = false;
    // do in registration
    async regIn() {
        // send card number (if set) and location id to server
        const cardNum = this.nextInCard != null ? this.nextInCard.cardNum : null;
        try {
            this.registering = true;
            if(this.nextInLocation != null && this.myposition != null) {
                const apiMsg = await this.api.sioRegIn(this.nextInLocation.locid, this.myposition, cardNum);
                // refresh view, next action will then be register out
                this.loadActiveSio();

                if (apiMsg != null) { // Something went wrong
                    if (apiMsg.num == 65 /* Validation error */) {
                        this.snackErrorMsg("Validering av registrering feilet. Prøv på nytt.");
                    } else {
                        this.snackErrorMsg(apiMsg.msg);
                    }
                } else {
                    this.activateTooQuickPreventor();
                    this.snackSuccessMsg("Innregistrering utført");
                    this.regcodeLocation = null; // Incase it was set
                    this.appReviewTrigger.run(1);
                }
            } else {
                this.snackErrorMsg("Mangler nødvendig anleggsinfo eller posisjon");
            }
        } catch (err) {
            this.emitError(err);
        } finally {
            this.registering = false;
        }
    }

    regOutValidationFailure = false;
    showRegOutNotAllowed = false;
    async regOut() {
        if (this.activeSio === null) {
          this.snackErrorMsg("Finner ikke aktiv innregistrering");
          return;
        }

        // reg-out requires geo
        if (this.activeSio.terminalLocation.regWithoutTerminal && this.activeSio.terminalLocation.mobileRegOutGeoRequired && this.myposition === null) {
          this.snackErrorMsg("Mangler nødvendig posisjon");
          return;
        }

        try {
          this.registering = true;

          const resp = await this.api.sioRegOutNow(this.activeSio.guid, this.myposition);
          this.nextInLocation = null; // In case it was set, reset it here so that user must choose location if multiple are available for regIn after regOut.
          await this.loadActiveSio();
          if(resp instanceof ApiMessage) {
            if (this.activeSio !== null && !this.activeSio.terminalLocation.regWithoutTerminal && !this.activeSio.terminalLocation.allowRegOutMobile) {
              this.showRegOutNotAllowed = true;
            } else {
              this.regOutValidationFailure = true;
            }
            this.snackErrorMsg("Utregistrering feilet. Prøv på nytt");
          } else {
            this.activateTooQuickPreventor();
            this.snackSuccessMsg("Utregistrering utført");
          }
        } catch (err) {
          this.emitError(err);
        } finally {
          this.registering = false;
        }
    }

    // tooQuicPrevento is used to avoid potential problem where user clicks register in and then without knowing it taps register out immediatly after.
    // And vice versa when registering out.
    // Adds a 5 seconds delay before user can register in/out again to avoid such confusion.
    pTooQuickPreventor = false;
    async activateTooQuickPreventor() {
        this.pTooQuickPreventor = true;
        await delay(5000);
        this.pTooQuickPreventor = false;
    }
    get tooQuickPreventor() {
        return this.pTooQuickPreventor;
    }

    snackStr: string | null = null;
    snackColor: string = "black";
    showSnack = false;

    get snackDelay(): number {
      return this.snackColor == "error" ? 10_000 : 3_000;
    }

    snackErrorMsg(txt: string) {
        this.snackColor = "error";
        this.snackStr = txt;
        this.showSnack = true;
    }
    snackSuccessMsg(txt: string) {
        this.snackColor = "success";
        this.snackStr = txt;
        this.showSnack = true;
    }

    get loading() {
        if(this.geoError != null) {
            return false;
        }
        if(this.registering) {
            return true;
        }
        if(this.regcodeRegistering) {
            return true;
        }
        if(!this.sioLoaded) {
            return true;
        }
        if(this.geoListenerPending) {
            return true;
        }
        if(this.geoAvailability > this.geoGranted) {
            return false;
        }
        return this.activeSio == null && this.availableInOutLocations == null ;
    }

    sioLoaded = false;
    async loadActiveSio() {
        this.sioLoaded = false;
        await this.baseApi.loadActiveSio();
        this.sioLoaded = true;
    }

    isIosSafari = isIosSafari();
    get iphoneWebResetPath() {
        return rd.docs.iphonewebreset.path;
    }

    get cardAddTo() {
        return {path: rd.start.card.add.path};
    }

    mapPromise(): Promise<google.maps.Map> {
        return (this.$refs.mapRef as any).$mapPromise;
    }

    // 1 = regcodeProcess initial view
    regcodeProcess = 0;
    // Regcode entered by user
    regcode: string | null = null;

    regcodeRegistering = false;
    regcodeLocation: TerminalLocation | null = null;

    async registerRegcode() {
        try {
            if(this.regcode != null) {
                this.regcodeRegistering = true;
                const resp = await this.api.registerRegcode(this.regcode);
                if (resp.location == null) {
                    if (resp.expired != null) {
                        this.snackErrorMsg(`Denne anleggskoden ble deaktivert ${resp.expired.toLocalDateTime()}. Se etter ny anleggskode.`);
                        this.regcodeRegistering = false;
                    } else if(!resp.valid) {
                        this.snackErrorMsg(`Ugyldig anleggskode. Kontroller inntastet verdi.`);
                        this.regcodeRegistering = false;
                    } else {
                        this.snackErrorMsg(`Korrekt anleggskode, men mobilregistrering er ikke aktivert på anlegget.`);
                        this.regcodeRegistering = false;
                    }
                } else { // Valid, location found, reload available locations
                    this.snackSuccessMsg(`Anleggskode bekreftet`);
                    this.regcodeLocation = resp.location;
                    this.loadBouncer.reset(); // So that reload below happens immediatly
                    await this.loadAvailableInOutLocations();
                    this.regcodeProcess = 0;

                }
            } else {
                this.snackErrorMsg("Anleggskode ikke utfyllt");
                this.regcodeRegistering = false;
            }
        } catch(err) {
            this.regcodeRegistering = false;
            this.emitError(err);
        }
    }

    get showForgetBtn() {
        if (this.regOutValidationFailure || this.showRegOutNotAllowed) {
          return false;
        }

        if(this.nextInLocation != null) {
            return (!this.showUnvRegNotOkInfo) && (!this.hasCard || this.nextInCard != null) && this.regcodeProcess === 0 && this.nextInLocation.regcodeRequired;
        } else if(!this.loading && this.activeSio != null && this.activeSio.terminalLocation.mobileRegRegcodeRequired) {
            return true;
        }
        return false;
    }
    showForgetDialog = false;
    isForgetting = false;
    async forgetLocation() {
        try {
            this.isForgetting = true;
            let locid = 0;
            if (this.nextInLocation != null) {
                locid = this.nextInLocation.locid;
            } else if (this.activeSio != null) {
                locid = this.activeSio.terminalLocation.id;
                this.regOut();
            }
            if (locid > 0) {
                const updCount = await this.api.forgetRegcode(locid);
                if (updCount > 0) {
                    await this.loadAvailableInOutLocations();
                }
            } else {
                throw new Error(`Location id to forget regcode at not set`);
            }
        } finally {
            this.showForgetDialog = false;
            this.isForgetting = false;
        }
    }

    get hseGuideline(): HseGuideline | null {
      return this.nextInLocation?.hseGuideline || null;
    }

    get hseGuidelineConfirmed(): boolean {
      return this.nextInLocation?.hseGuidelineConfirmed || false;
    }

    get needHseGuidelineConfirm() {
      const enabled = this.nextInLocation?.hseGuidelineEnabled || 0;
      return this.hseGuideline != null && enabled > 0 && !this.hseGuidelineConfirmed;
    }

    showHseVerifDialog = false;

    onHseGuidelineConfirmed(id: number) {
      if(this.nextInLocation != null && this.nextInLocation.hseGuideline?.id == id) {
        // Just set the loaded location guideline confirmed directly without any server reload to save time.
        this.nextInLocation.hseGuidelineConfirmed = true;
        this.snackSuccessMsg(`HMS Bekreftet. Du kan nå registrere inn`);
      } else {
        throw new Error(`HMS retningslinje ${id} bekreftet, men ikke lenger korrekt i forhold til valgt anlegg`);
      }
    }

    private appReviewTrigger = new AppReviewTrigger(this.nativeApi, this.api);

    mounted() {
        // Wait for both of these to be sure the google maps is initialized before trying to use it.
        const mp: Promise<google.maps.Map> = this.mapPromise();
        const gw = this.googleWaiter();
        gw.then(() => {
            mp.then(() => {
                this.mapLoaded = true;
            });
        });
    }


    async onCreated() {
        this.loadActiveSio();
        await this.geoApi.checkAvailability();
        this.onGeoAvailabilityChanged();
    }

    created() {
       this.onCreated();
    }

    beforeDestroy() {
        this.geoApi.stopGeolistener();
        this.appReviewTrigger.cancel();
    }
}
